// Minimalny dashboard layout: React + MUI
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './Router/AppRoutes';
import { useAuthInterceptor } from './Features/Auth/hooks/useAuthInterceptor';
import { useTokenRefresh } from './Features/Auth/hooks/useTokenRefresh';
import { useTokenExpiryWarning } from './Features/Auth/hooks/useTokenExpiryWarning';

function App() {
  // Initialize auth interceptor
  useAuthInterceptor();

  // Automatic token refresh (5 min before expiry)
  useTokenRefresh();

  // Show warning toast (5 min before expiry)
  useTokenExpiryWarning();

  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
}

export default App;
